// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Services_KvResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/services/kv
 *
 * Key-value list of services for dropdown selects.
 * Wire shape: `dados: Services_KvRow[]` — emitted directly as `dados`.
 */
import type { Services_KvRow } from './Services_KvRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Services_KvResponseDados = Services_KvRow[];

export type Services_KvResponse = ApiResponse<Services_KvResponseDados>;

registerResponseContract('Services_KvResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      value: { type: 'number',  required: true },
      label: { type: 'string',  required: true },
    },
  },
})
